import React from 'react';
import { Link } from 'react-router-dom';
import S from './style';
import TranslateStatic from '../../locales/TranslateStatic';

import YumurtlamaImg from '../../assets/tesa.jpeg';
import AsrmEshre from '../../components/asrmEshre';

export function Tesa() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="TESA / MIKRO TESE" /></h1>
          <h2 className="subtitle"><TranslateStatic string="TESA / MIKRO TESE2" /></h2>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="TESA / MIKRO TESE" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="info-container">
          <div className="image-wrapper">
            <img src={YumurtlamaImg} alt="TESA / MIKRO TESE" />
          </div>

          <div className="date-info">
            <TranslateStatic string="SonGuncellemeTarihi" /> 19.02.2025
          </div>

          <div className="text-content">
            <p>
              <TranslateStatic string="tesaP1" />
            </p>
            <p>
              <TranslateStatic string="tesaP2" />
            </p>
            <h3><TranslateStatic string="tesah3-1" /></h3>
            <p>
              <TranslateStatic string="tesaP3" />
            </p>
            <h3><TranslateStatic string="tesah3-2" /></h3>
            <p>
              <TranslateStatic string="tesaP4" />
            </p>
            <p>
              <TranslateStatic string="tesaP5" />
            </p>
            <p>
              <TranslateStatic string="tesaP6" />
            </p>
            <p>
              <TranslateStatic string="tesaP7" />
            </p>
            <h3><TranslateStatic string="tesaH4" /></h3>
            <p>
              <TranslateStatic string="tesaP9" />
            </p>
          </div>
        </div>

        <AsrmEshre />
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
